import * as $ from "jquery";
import 'bootstrap-datepicker';
import {MapView} from "./MapView";
import {Server} from "./Server";
import {MapArea, TimeFilter} from "./Types";
import {ListPanel} from "./ListPanel";
import {Format} from "./Format";

const TITLES: Record<TimeFilter, string> = {
    TODAY: 'Данас', TOMORROW: 'Сутра', THIS_WEEK: 'Наредна 3 дана',
    AT_DATE: 'На датум', PLANNED: 'Сви термини', LATEST: 'Сви термини'
};

export class MapFilters {

    public static setup(): void {
        // vremenski filter
        $('input[name=filterTime]').on('change', () => {
            const time = $('input[name=filterTime]:checked').val() as TimeFilter;
            MapView.mapOptions.time = time;
            $('#filterCalendar').toggle(time === 'AT_DATE');
            ListPanel.setTitle(time === 'AT_DATE' ? MapView.mapOptions.atDate || TITLES[time] : TITLES[time]);
            MapView.reloadMapData();
        });

        // oblast
        const areas: Record<string, MapArea> = {};
        $.get(Server.endpoint + '/events/data/areas').then((data: MapArea[]) => {
            data.forEach(a => {
                areas[a.code] = a;
                $('#filterArea').append($('<option></option>').val(a.code).text(a.name));
            });
            MapFilters.applyUrlParams();
        });
        $('#filterArea').on('change', () => {
            const code = $('#filterArea').val() as string;
            MapView.mapOptions.area = code;
            const a = areas[code];
            if (a) {
                MapView.focus(a.latitude, a.longitude, a.zoom);
            } else {
                MapView.resetView();
            }
            MapView.reloadMapData();
        });

        // prikaz svih odbora (podrazumevano iskljuceno – prikazuju se samo termini)
        MapView.mapOptions.showPoints = $('#filterShowPoints').prop('checked');
        $('#filterShowPoints').on('change', () => {
            MapView.mapOptions.showPoints = $('#filterShowPoints').prop('checked');
            MapView.reloadMapData();
        });

        // kalendar
        const today = new Date();
        MapView.mapOptions.atDate = Format.date(today);
        $('#filterAtDate').datepicker({
            language: 'sr', todayHighlight: true, todayBtn: 'linked', format: 'dd.mm.yyyy.'
        }).on('changeDate', (e: any) => {
            MapView.mapOptions.atDate = e.format();
            $('#ftDateLabel').text(e.format());
            ListPanel.setTitle(e.format());
            MapView.reloadMapData();
        });
        $('#filterAtDate').datepicker('update', today);
    }

    /** ?time=today|tomorrow|week|all & ?area=BG – za deljenje linkova. */
    private static applyUrlParams(): void {
        try {
            const p = new URLSearchParams(window.location.search);
            const t = (p.get('time') || '').toLowerCase();
            const map: Record<string, string> = {today: 'ftToday', tomorrow: 'ftTomorrow', week: 'ftWeek', all: 'ftAll'};
            if (map[t]) $('#' + map[t]).prop('checked', true).trigger('change');
            const area = (p.get('area') || '').toUpperCase();
            if (area && $('#filterArea option[value="' + area + '"]').length) {
                $('#filterArea').val(area).trigger('change');
            }
        } catch (e) {
            console.error(e);
        }
    }
}
